<template>
    <div class="travel_trajectory_map">
        <div style="font-size: 14px;color: #0F1A3A;font-weight: bold;">{{$t('行程统计.车辆实时信息')}}</div>
        <div style="margin-top: 20px;">
            <div style="position: relative;">

                <KingLongMap @LoadCompleted="MapLoadCompleted" mapId="klmap_track_map" ref="map"
                    style="width: 100%; height: 400px" />
                <div style="          position: absolute;        
          left: 0px;
          right: 0px;
          bottom: 0;
          padding: 0 8px;background: #000000;opacity: 0.7;
        ">
                    <TrackSlider theme="dark" v-model="current_slider" ref="trackslider" :max="totalCount" />

                </div>
            </div>
            <div style="margin-top: 32px;">
                <el-row>
                    <el-col class="track_data_item" :span="6">
                        <track_data_item :title="$t('行程统计.当前距离')" :value="gpsinfo.Distance + ' km'"></track_data_item>

                    </el-col>
                    <el-col class="track_data_item" :span="6">
                        <track_data_item :title="$t('行程统计.当前车速')" :value="gpsinfo.Speed + ' km/h'"></track_data_item>
                    </el-col>
                    <el-col class="track_data_item" :span="6">
                        <track_data_item :title="$t('行程统计.当前时间')" :value="gpsinfo.GpsDateTime"></track_data_item>
                    </el-col>
                    <el-col class="track_data_item" :span="6">
                        <track_data_item :title="$t('行程统计.当前位置')" :value="gpsinfo.Position"></track_data_item>
                    </el-col>
                    <!-- <el-col class="track_data_item" :span="6">
                        <track_data_item title="当前距离" value="49.77 km"></track_data_item>
                    </el-col> -->
                    <!-- <el-col class="track_data_item" :span="6">
                        <track_data_item title="当前距离" value="49.77 km"></track_data_item>
                    </el-col>
                    <el-col class="track_data_item" :span="6">
                        <track_data_item title="当前距离" value="49.77 km"></track_data_item>
                    </el-col>
                    <el-col class="track_data_item" :span="6">
                        <track_data_item title="当前位置" value="厦门市翔安区锦绣路… "></track_data_item>
                    </el-col> -->
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import KingLongMap from "@/components/KingLongMap";
import TrackSlider from "@/components/TrackSlider";
import track_data_item from './track_data_item.vue'
import { getIconByDirection } from "@/utils/VehicleHelper";

import { formatTime } from "@/utils/longyi";
export default {
    components: {
        track_data_item,
        KingLongMap,
        TrackSlider

    },
    props: {
      
    },

    data() {
        return {
            totalCount: 0,
            current_index: 0, // 当前轨迹索引
            current_slider: 0, //当前播放位置
            current_marker: undefined,
            isMapLoaded: false,
            isDataLoaded: false,
            current_play_state: false,
            totalCount: 0,
            CarNo:"",
            GpsData: [],
            gpsinfo: {
                Distance: "",
                Speed: "",
                GpsDateTime: "",
                Position: ""

            }

        }
    },
    beforeDestroy() {
        console.log("sing-destroy");
        this.$refs.map.clearAll();
    },
    watch: {
        current_slider() {
            this.current_index = this.current_slider;
            this.updateGpsPos();
        },
    },
    methods: {
        updateGpsPos() {
            //更新位置

            var _this = this;
            // console.log(_this.current_marker);

            if (_this.$refs.map) _this.$refs.map.removeMarkerById("v_last_gps");
            _this.current_marker = undefined;

            this.gpsinfo = _this.GpsData[_this.current_index];
            this.gpsinfo.GpsDateTime = formatTime(this.gpsinfo.GpsDateTime)


            if (this.gpsinfo && _this.$refs.map) {
                var iconUrl = getIconByDirection(0);//this.gpsinfo.Direction);
                _this.$refs.map.addMarker(
                    "v_last_gps",
                    this.CarNo,
                    this.gpsinfo.lng,
                    this.gpsinfo.lat,
                    iconUrl
                );

                if (_this.current_index == 0)
                    _this.$refs.map.setCenter(
                        this.gpsinfo.lng,
                        this.gpsinfo.lat
                    );
            }
        },
        showData(gpsData,CarNo) {

            //删除原来的地图上面的内容
             console.log(gpsData);//不打印就没有数据？
            this.GpsData = gpsData;
            this.CarNo = CarNo;

            if(!this.isMapLoaded){
                this.isDataLoaded = false;
                return;

            }
             this.isDataLoaded=true;
            this.$refs.map.clearAll();
            //画轨迹
            this.totalCount = gpsData.length;
            this.current_index = 0;
            this.current_slider = 0;


            this.$refs.map.addPolyline("gps_line", "gps_line", gpsData, 3, "#2A7AFF");

            //添加起点和终点

            this.$refs.map.addMarker(
                "gps_begin_marker",
                "起点",
                gpsData[0].lng,
                gpsData[0].lat,
                "assets/svgs/ic_dingwei_qidian_lv@2x.png",
                null,
                27,// 54,
                36,// 72
            );
            this.$refs.map.addMarker(
                "gps_end_marker",
                "终点",

                gpsData[gpsData.length - 1].lng,
                gpsData[gpsData.length - 1].lat,
                "assets/svgs/ic_dingwei_zhongdian_hong@2x.png", null,
                27,// 54,
                36,// 72
            );


            this.$refs.trackslider.play();

            this.current_play_state = true;

           

            //当前点--
            //添加点
            //this.$refs.map.addMarker("gps_marker", "gps_marker", gpsData[0], 3, "#2A7AFF");


            //显示轨迹数据
        },
        MapLoadCompleted() {
            this.isMapLoaded = true;

            if( ! this.isDataLoaded)
                this.showData(this.GpsData,this.CarNo);

        },
    }
}
</script>
<style>
/* el-col 从第四个开始 */
.data_item:nth-child(n+4) {
    margin-top: 10px;
}

.track_data_item:nth-child(n+5) {
    margin-top: 10px;
}
</style>